import PropTypes from 'prop-types';
import cx from 'classnames';
import NextLink from 'next/link';

import * as style from './anchor.module.scss';

const Anchor = ({ children, className, href, label, ...rest }) => {
  const isInternal = /^\/(?!\/)/.test(href);
  const aTagProps = isInternal ? {} : { rel: 'noreferrer' };

  if (label) {
    aTagProps['aria-label'] = label;
  }
  // https://github.com/vercel/next.js/issues/16107
  // Empty urls need a better default behavior
  // Server:
  // Error occurred prerendering page "/news/2021/02/09/the-vote". Read more: https://nextjs.org/docs/messages/prerender-error
  // TypeError: Cannot destructure property 'auth' of 'urlObj' as it is undefined.
  // Client:
  // Error: Failed prop type: The prop `href` expects a `string` or `object` in `<Link>`, but got `undefined` instead.

  return (
    <NextLink href={href} passHref {...rest}>
      <a className={cx(className, style.anchor)} {...aTagProps}>
        {children}
      </a>
    </NextLink>
  );
};

Anchor.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  label: PropTypes.string,
};

export default Anchor;
